<template lang="pug">
PaymentButton(
  ref="content"
  kr-resource
  type="button"
  v-show="isVisible"
  :class="dynamicClasses"
  :style="styles"
  :disabled="isDisabled"
  @click="btnClick"
)
</template>

<script>
import PaymentButton from '@/host/components/controls/PaymentButton'

import { FormPaymentButtonMixin } from '@/host/components/mixins/FormPaymentButton'
import { StandalonePaymentButtonMixin } from '@/host/components/mixins/StandalonePaymentButton'
import { SmartFormClickMixin } from '@/host/components/mixins/SmartFormClick'

import { mapGetters, mapState } from 'vuex'
import Events from '@/configuration/Events'

/**
 * @see KJS-4366 | Replace html button by PaymentButton
 */
export default {
  name: 'KryptonPaymentButton',
  components: { PaymentButton },
  mixins: [
    FormPaymentButtonMixin,
    StandalonePaymentButtonMixin,
    SmartFormClickMixin
  ],
  computed: {
    ...mapGetters([
      'activeFormId',
      'isExtrasFormVisible',
      'cardsFormExpanded',
      'outsideCardsForm',
      'isCardBrandAsMethodForm',
      'isSinglePaymentButton'
    ]),
    ...mapState(['forms']),
    ...mapState({
      selectedMethod: ({ smartForm }) => smartForm.selectedMethod
    }),
    isLoading() {
      return (
        !this.hasError &&
        this.activeFormId === this.context?.formId &&
        (this.processingPayment === true || this.spinnerVisible) &&
        !this.isExtrasFormVisible
      )
    },
    canDetach() {
      return (
        !this.isSinglePaymentButton &&
        this.cardsFormExpanded &&
        !this.outsideCardsForm
      )
    },
    currentPaymentMethod() {
      if (this.isSinglePaymentButton) return this.selectedMethod

      const activeFormKey = Object.keys(this.forms).find(
        key => this.forms[key] === this.activeFormId
      )
      return activeFormKey === 'default' ? 'CARDS' : `CARDS:${activeFormKey}`
    }
  },
  created() {
    // Payment trigger
    this.$busOn(Events.krypton.form.submit, ({ formId }) => {
      if (!this.isDisabled && this.context.formId === formId) {
        this.disableButton()
        this.cleanError()
        this.$bus.$emit(Events.krypton.form.pay, this.context.formId)
      }
    })
  },
  methods: {
    async btnClick(e) {
      // Resolve interceptors first
      try {
        await this.intercept({
          name: 'paymentButton',
          args: [this.context.formId]
        })
      } catch (e) {
        return false
      }

      if (
        await this.interruptsExecution(
          this.currentPaymentMethod,
          'beforePaymentStart',
          this.context.formId
        )
      )
        return false

      e.preventDefault()
      if (!this.isDisabled) {
        this.disableButton()
        this.cleanError()
        this.$bus.$emit(Events.krypton.form.pay, this.context.formId)
        this.focusHelper()
      }
    }
  }
}
</script>
